import * as React from "react";
const SvgProdukter = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	id: "produkter_svg__Layer_1",
	x: 0,
	y: 0,
	viewBox: "0 0 48.2 48.2",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.4 7h11.3v15.6H6.1V11.3C6.1 9 8 7 10.4 7M26.5 7H38c2.2 0 4 1.8 4 4v11.5H26.5zM6.1 27.3h15.6v15.6H10.3c-2.3 0-4.1-1.8-4.1-4.1V27.3zM26.5 27.3h15.6v11.6c0 2.2-1.8 4-4 4H26.5z",
	style: { fill: "currentColor" }
}));
export default SvgProdukter;
